<template>
  <ticket-flow-lib
    :application-id="deTicketApplications.MIPE"
    :email="userEmail"
    :case-type-options="itemSubTypes"
    :get-user-case-reference-number-types-service="
      getUserCaseReferenceNumberTypesService
    "
    :save-user-case-service="saveUserCaseService"
    :validate-reference-number-service="validateReferenceNumberService"
    :get-user-case-screens-service="getUserCaseScreensService"
    :get-case-modules-service="getCaseModulesService"
    :get-ticket-catalogues="getTicketCatalogues"
    @close="handleClose"
  />
</template>

<script>
// libs
import TicketFlowLib from "@quisit/ticket-flow";

// services
import {
  getUserCaseReferenceNumberTypes as _getUserCaseReferenceNumberTypes,
  saveUserCase as _saveUserCase,
  validateReferenceNumber as _validateReferenceNumber,
  getUserCaseScreens as _getUserCaseScreens,
  getCaseModules as _getCaseModules,
  getTicketCatalogues as _getTicketCatalogues,
  getItemSubTypes as _getItemSubTypes,
} from "@/modules/helpdesk/api.js";

// constants
import deTicketApplications from "@/utils/constants/deTicketApplications.js";

export default {
  name: "TicketFlow",
  components: {
    TicketFlowLib,
  },
  data() {
    return {
      deTicketApplications,
      itemSubTypes: [],
    };
  },
  computed: {
    userEmail()
    {      
      return this.userProfile.email;
    }
  },
  mounted() {
    this.getItemSubTypes();
  },
  methods: {
    getUserCaseReferenceNumberTypesService(payload) {
      return _getUserCaseReferenceNumberTypes(payload);
    },
    saveUserCaseService(payload) {
      return _saveUserCase(payload);
    },
    validateReferenceNumberService(value, type) {
      return _validateReferenceNumber(value, type);
    },
    getUserCaseScreensService(moduleId) {
      return _getUserCaseScreens(moduleId);
    },
    getTicketCatalogues(itemSubTypeId) {
      return _getTicketCatalogues(itemSubTypeId);
    },     
    getCaseModulesService(caseTypeId) {
      return _getCaseModules({        
        caseTypeId
      });
    },
    handleClose() {
      this.$emit('close');
    },
    async getItemSubTypes() {
      const response = await _getItemSubTypes();
      if (response?.data) {
        this.itemSubTypes = response.data;
      }
    },
  },
};
</script>
